import { render, staticRenderFns } from "./OptionalGroupIngredient.vue?vue&type=template&id=da8504d6&"
import script from "./OptionalGroupIngredient.vue?vue&type=script&lang=ts&"
export * from "./OptionalGroupIngredient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports